import { render } from "./SwdSelect.vue?vue&type=template&id=2900a01e"
import script from "./SwdSelect.vue?vue&type=script&lang=js"
export * from "./SwdSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__